import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setDispatch } from '../../modules/dispatch'
import { Card, Tag, Icon, Divider, Tooltip, Collapse, Avatar, } from 'antd'
import moment from 'moment'
import _ from 'lodash'
import Format from '../Format'
import { FormattedMessage } from 'react-intl'
import DispatchStatus from '../DispatchStatus'
import DispatchDocs from '../DispatchDocs'
import HasPermission from '../HasPermission'
import apis from '../../config/apis'

import './index.css'

const Panel = Collapse.Panel

class DispatchItem extends Component {

  static getStatus(dispatch) {
    let status = {
      name: 'Solicitud creada',
      className: 'dispatch-status-creada',
      badgeClassName: 'dispatch-status-badge-recibida'
    }

    if (dispatch.requestedAt) {
      status = {
        name: 'Pre Solicitud',
        className: 'dispatch-status-pre-solicitud',
        badgeClassName: 'dispatch-status-badge-pre-solicitud'
      }
    }

    if (dispatch.receivedAt) {
      status = {
        name: 'Solicitud recibida',
        className: 'dispatch-status-recibida',
        badgeClassName: 'dispatch-status-badge-recibida'
      }
    }

    if (dispatch.approvedAt) {
      status = {
        name: 'Solicitud aprobada',
        className: 'dispatch-status-aprobada',
        badgeClassName: 'dispatch-status-badge-aprobada'
      }
    }

    if (dispatch.startedAt) {
      status = {
        name: 'Tránsito iniciado',
        className: 'dispatch-status-iniciada',
        badgeClassName: 'dispatch-status-badge-iniciada'
      }
    }

    if (dispatch.startedAt &&
      dispatch.billType &&
      dispatch.amount &&
      dispatch.currency &&
      dispatch.type &&
      dispatch.customer &&
      dispatch.origin &&
      dispatch.destination &&
      dispatch.supplier &&
      dispatch.vehicle &&
      dispatch.vehicletype &&
      dispatch.economicNumber &&
      dispatch.driver &&
      (dispatch.items && dispatch.items.length) &&
      (dispatch.references && dispatch.references.length)) {

      // const schedule = _.first(dispatch.schedule)

      // if (schedule.customerArrivalTime &&
      //     schedule.shipperTime &&
      //     schedule.pedimentTime &&
      //     schedule.customerDepartureTime &&
      //     schedule.deliveryTime &&
      //     schedule.endDate) {
      // }

      status = {
        name: 'Listo para finalizar',
        className: 'dispatch-status-completada',
        badgeClassName: 'dispatch-status-badge-completada'
      }
    }

    if (dispatch.finishedAt) {
      status = {
        name: 'Tránsito finalizado',
        className: 'dispatch-status-finalizada',
        badgeClassName: 'dispatch-status-badge-finalizada'
      }
    }

    if (dispatch.closedAt) {
      status = {
        name: 'Tránsito cerrado',
        className: 'dispatch-status-cerrada',
        badgeClassName: 'dispatch-status-badge-cerrada'
      }
    }

    if (dispatch.canceledAt) {
      status = {
        title: `Cancelado por ${dispatch.canceledBy.name} ${dispatch.canceledBy.lastName}`,
        name: `Tránsito cancelado por ${dispatch.canceledBy.name} ${dispatch.canceledBy.lastName}`,
        className: 'dispatch-status-cancelado',
        badgeClassName: 'dispatch-status-badge-cancelado'
      }
    }
    
    if (dispatch.sapAt) {
      status = {
        name: `Tránsito pendiente de facturar`,
        className: `dispatch-status-no-facturado`,
        badgeClassName: `dispatch-status-badge-no-facturado`
      }
    }

    if (dispatch.billedAt) {
      status = {
        name: `Tránsito Facturado`,
        className: `dispatch-status-facturado`,
        badgeClassName: `dispatch-status-badge-facturado`
      }
    }


    return status
  }

  static getTotal(dispatch) {
    let total = 0

    if (dispatch) {
      total += dispatch.amount || 0
      total += _.sumBy(dispatch.charges, 'amount')
    }

    return total
  }

  render() {
    const dispatch = _.find(this.props.dispatches, { id: this.props.id })

    return (
      <Card
        onClick={() => { this.props.setDispatch(dispatch.id) }}
        className={[
          DispatchItem.getStatus(dispatch).className,
          this.props.active ? 'dispatch-item active' : 'dispatch-item'
        ]}
      >
        <div style={{ display: 'flex' }}>
          <Tooltip title={`${dispatch.createdBy.name} ${dispatch.createdBy.lastName}`}>
            <Avatar src={`${apis.avatar.url}/${dispatch.createdBy.picture}`}>
              {dispatch.createdBy.name && dispatch.createdBy.name[0].toUpperCase()}
              {dispatch.createdBy.lastName && dispatch.createdBy.lastName[0].toUpperCase()}
            </Avatar>
          </Tooltip>
          <div style={{ marginLeft: 10 }}>
            <div>
              <Tag color="geekblue">Tránsito: {_.padStart(dispatch.id, 5, 0)}</Tag>
              <h3 className="dispatch-title">{dispatch.type.name}</h3>
            </div>
          </div>
        </div>
        <div style={{ marginBottom: 5 }}>
          <small>{moment(dispatch.createdAt).format('lll')}</small>
          <span className="dispatch-icons">
            {
              _.find(dispatch.items, 'hazmat') &&
              <Tooltip title="Hazmat">
                <Icon type="warning" className="warning" />
              </Tooltip>
            }
            {
              _.find(dispatch.items, 'damaged') &&
              <Tooltip title="Damaged">
                <Icon type="frown-o" className="warning" />
              </Tooltip>
            }
            {dispatch.urgent &&
              <Tooltip title="Urgent">
                <Icon type="exclamation-circle-o" className="danger" />
              </Tooltip>
            }
            {
              dispatch.finishedAt &&
              <Icon type="lock" />
            }
          </span>
        </div>
        <div>
          <b><FormattedMessage id={`Attribute.dispatch.customer`} />:</b>&nbsp;
                    <Format
            model="dispatch"
            attribute="customer"
            value={dispatch.customer}
          />
        </div>
        <div>
          <b><FormattedMessage id={`Attribute.dispatch.supplier`} />:</b>&nbsp;
                    <Format
            model="dispatch"
            attribute="supplier"
            value={dispatch.supplier}
          />
        </div>
        <div style={{ marginTop: 10 }}>
          <HasPermission name={'Editar'}>
            {!dispatch.canceledAt && <DispatchStatus id={this.props.id} />}
          </HasPermission>
        </div>
        <div className="dispatch-status">
          <Tag className={DispatchItem.getStatus(dispatch).badgeClassName}>{DispatchItem.getStatus(dispatch).name}</Tag>
        </div>
        <div className="dispatch-action-container">
          <div className="dispatch-action">
            <DispatchDocs id={dispatch.id} />
          </div>
        </div>
        <div className={`dispatch-amount ${!dispatch.amount ? 'dispatch-amount-warning' : ''}`}>
          <Tooltip title={!dispatch.amount ? 'Tránsito sin importe' : 'Importe más cargos extras'}>
            ${DispatchItem.getTotal(dispatch).toFixed(2)}
          </Tooltip>
        </div>
        <Divider className="dispatch-divider" />
        <div onClick={e => { e.stopPropagation() }}>
          <Collapse bordered={false}>
            <Panel header={dispatch.canceledAt ? 'Motivo de cancelación' : 'Descripción'} style={{ border: 0 }}>
              {dispatch.cancelComment || dispatch.comments || 'Sin comentarios'}
            </Panel>
          </Collapse>
        </div>
      </Card >
    )
  }

}

const mapStateToProps = state => ({
  locale: state.intl.locale,
  dispatches: state.dispatch.items
})

const mapDispatchToProps = dispatch => bindActionCreators({
  setDispatch,
}, dispatch)


export default connect(mapStateToProps, mapDispatchToProps)(DispatchItem)



// WEBPACK FOOTER //
// ./src/containers/DispatchItem/index.js